import { DocumentNode, gql } from '@apollo/client';
import { Tooltip, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { RespondButton } from '@/components/Post/components/RespondButton';
import { ThumbsUpIcon } from '@/imports/ui/chakra/feather';

import { LikeCount_PostFragment } from './graphql-types/LikeCount_PostFragment';

import { useListOfAuthors } from '../../hooks/useListOfAuthors';
import { PostLikesModal } from './components/PostLikesModal';

export const LikeCount: React.FC<{
  post: LikeCount_PostFragment;
}> & {
  postFragment: DocumentNode;
} = ({ post }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const listOfAuthorsWhoLiked = post.reactions
    .map((reaction) => reaction.user?.displayName)
    .filter((displayName): displayName is string => !!displayName);

  const { readableListOfAuthors } = useListOfAuthors(listOfAuthorsWhoLiked, 6);
  return (
    <>
      <PostLikesModal postId={post._id} isOpen={isOpen} onClose={onClose} />

      <Tooltip
        label={readableListOfAuthors}
        isDisabled={!post.reactionCount}
        placement="top"
        p="2"
      >
        <RespondButton
          onClick={
            !post.reactionCount || post.reactionCount === 0 ? undefined : onOpen
          }
          color="gray.600"
          fontWeight="regular"
          leftIcon={<ThumbsUpIcon />}
        >
          {post.reactionCount}
        </RespondButton>
      </Tooltip>
    </>
  );
};

LikeCount.postFragment = gql`
  fragment LikeCount_PostFragment on PostV2 {
    _id
    reactionCount
    reactions {
      _id
      user {
        _id
        displayName
      }
    }
  }
`;
